
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_USER_PUBLIC_INFO from "@/apollo/user/GetContractorPublicInfoForManager.gql";

import CardInfoChip from "@/components/card/CardInfoChip.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ContractorAbout from "@/components/contractors/ContractorAbout.vue";
import AddContractorToCompany from "@/components/contractors/AddContractorToCompany.vue";
import UILink from "@/components/common/UILink.vue";
import RemoveManagerContractorRequest from "@/components/contractors/RemoveManagerContractorRequest.vue";
import ContractorManagerInformationProvider from "@/components/contractors/ContractorManagerInformationProvider.vue";
import ContractorFullInformationLink from "@/components/contractors/ContractorFullInformationLink.vue";

import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";

@Component({
  components: {
    ContractorAbout,
    CardInfoChip,
    LoadingOverlay,
    AddContractorToCompany,
    UILink,
    RemoveManagerContractorRequest,
    ContractorManagerInformationProvider,
    ContractorFullInformationLink,
  },
  apollo: {
    contractorUser: {
      query: GET_USER_PUBLIC_INFO,
      variables() {
        return {
          id: this.contractorUserId,
          companyId: this.company.id,
          managerUserId: this.managerUserId,
        };
      },
      update: (data) => data.user_by_pk,
    },
  },
})
export default class ContractorAboutForManager extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
   @Prop({ type: Object, required: true }) readonly currentUser!: User;
     @Prop({ type: Boolean, required: false, default: true })
  readonly isAdmin!: boolean;
  @Prop({ type: String, required: true }) readonly managerUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserManagerId!: string;

  roles = Roles;

  contractorUser?: User;
  processing: boolean = false;
  componentKey = 0;

  created() {
    this.$root.$on('refetch', () => {
      this.$apollo.queries.contractorUser.refetch();
      this.componentKey += 1;
    })
  }

  get isPublic(): boolean {
    if (this.contractorUser) {
      return this.contractorUser.is_public!;
    }
    return false;
  }
}
